export const GET_RESOURCE_DETAILS_DATA = "GET_RESOURCE_DETAILS_DATA";
export const GET_ALL_RESOURCE_DATA = "GET_ALL_RESOURCE_DATA";
export const GET_FEATURED_RESOURCE_DATA = "GET_FEATURED_RESOURCE_DATA";
export const GET_PUBLIC_CATEGORY = "GET_PUBLIC_CATEGORY";
export const PAYMENT_HISTORY = "PAYMENT_HISTORY";
